import client from "./client";

const endpoint = "airport";

const getAirportByIataCode = ({ keyword }, { cancelToken } = {}) =>
  client.get(`${endpoint}/?keyword=${keyword}`, undefined, { cancelToken });

export { getAirportByIataCode };
